import React from "react";
import { ToastContainer } from "react-toastify";
import ReArrangeCategory from "../../components/ProductManager/Category/ReArrangeCategory";

export const ReArrangeCategoryPage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <ReArrangeCategory />
        </div>
      </div>
    </div>
  );
};
